const FormatDate = (dataISO, getHours = true, format = 1) => {
    const dt = new Date(dataISO);
    const day = String(dt.getDate()).padStart(2, '0');
    const month = String(dt.getMonth() + 1).padStart(2, '0'); // Janeiro é 0
    const year = dt.getFullYear();
    const hour = String(dt.getHours()).padStart(2, '0');
    const minutes = String(dt.getMinutes()).padStart(2, '0');

    let formattedDate = '';
    if (format == 2) formattedDate = `${year}-${month}-${day}`;
    else formattedDate = `${day}/${month}/${year}`;

    if (getHours == true) formattedDate += ` ${hour}:${minutes}`;

    return formattedDate;
}

export default FormatDate;